import React from "react";
import StoreAction from "../constants/store-action";
export default (props) => {
    const [isExtended, setIsExtended] = React.useState(false);
    const handleMoreInformationClick = () => {
        setIsExtended(!isExtended);
    };
    const updateAddons = (newAddons) => {
        props.dispatchStoreAction(StoreAction.UPDATE_NAMED_VALUE, {
            type: "insurance",
            name: "addons",
            value: newAddons,
        });
    };
    const handleCheckChange = (e) => {
        const addons = [...props.data.insurance.addons];
        const index = addons.indexOf(props.name);
        const hasElement = index >= 0;
        if (e.target.checked && !hasElement) {
            addons.push(props.name);
            updateAddons(addons);
        }
        else if (!e.target.checked && hasElement) {
            addons.splice(index, 1);
            updateAddons(addons);
        }
    };
    const isChecked = props.data.insurance.addons.includes(props.name);
    return (React.createElement("div", { "data-ecom-borderbox": "", className: `repeat-m-half ${props.isDisabled ? "bg-accent" : ""}` },
        React.createElement("div", { "data-ecom-columnrow": "" },
            React.createElement("div", { className: "column" },
                React.createElement("div", { "data-ecom-inputselection": "checkbox center-input" },
                    React.createElement("input", { type: "checkbox", id: props.id, disabled: props.isDisabled, checked: isChecked, onChange: handleCheckChange }),
                    React.createElement("label", { htmlFor: props.id },
                        React.createElement("span", { className: "text" },
                            React.createElement("span", { className: "l-block" }, props.title),
                            React.createElement("span", { className: "l-block font-size-small m-t-mini" },
                                React.createElement("button", { "data-ecom-link": "font-size-inherit", onClick: handleMoreInformationClick },
                                    "Visa ",
                                    isExtended ? "mindre" : "mer")))))),
            React.createElement("div", { className: "column font-medium" },
                props.monthlyPrice,
                " kr/m\u00E5n")),
        isExtended && (React.createElement("div", { "data-ecom-content": "", className: "m-t-half" },
            React.createElement("p", null, props.description)))));
};
